import React, { useEffect, useState, useCallback, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { isEqual } from 'lodash'
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import SalesByProductShow from './SalesByProductShow';
import { getPosSalesByProductData, handleLoader } from '../../../../redux/actions/SalesByProductAction';
import { months } from '../../CompareMonth/helper';
import { setCurrencyFormat, findMonthsBetweenDates } from '../../../../utils/helpers';
import ViewSalesReportModal from '../../SalesCategoryByDay/ViewSalesReportModal';
import {
  filterShowWise, filterWeeklyMonthYear,
  vendorNameMapping, sortType
} from '../../helper';

const quarterlyMonth = ['Jan-Feb-Mar', 'Apr-May-Jun', 'Jul-Aug-Sep', 'Oct-Nov-Dec']


const SalesByProduct = ({ dispatch, rtl }) => {
  const { t } = useTranslation('common');
  const location = useLocation();

  const currentYear = moment().format('YYYY');
  const currentMonth = moment().format('MMM');
  const prevMonth = moment().subtract(5, 'months').format('MMM');

  const { salesByProductData, salesChannelFilterData, isLoading } = useSelector(
    ({ salesByProductReducer, marketPlaceReducer }) =>
    ({
        salesByProductData: salesByProductReducer?.salesByProductData,
        salesChannelFilterData: marketPlaceReducer.salesChannel,
        isLoading: salesByProductReducer?.isLoading
    })
  );

  const salesChannelRef = useRef({})

  const [dataToShow, setDataToShow] = useState(salesByProductData?.modal?.data);
  const [showMarketPlaceMessage, setShowMarketPlaceMessage] = useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const [currentlyShow, setCurrentlyShow] = useState(filterShowWise?.[0])
  const [filterData, setFilterData] = useState({});
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [maxValueObj, setMaxValueObj] = useState({})
  const [month2, setMonth2] = useState({ year: currentYear, month: currentMonth })
  const [month1, setMonth1] = useState({ year: currentYear, month: prevMonth });
  const [tempMonth2, setTempMonth2] = useState({ year: currentYear, month: currentMonth });
  const [tempMonth1, setTempMonth1] = useState({ year: currentYear, month: prevMonth })
  const [selectedShowOptions, setSelectedShowOptions] = useState(filterWeeklyMonthYear?.[0]);
  
  const filterBasedOnFilter = (item) => {
    const filters = Object.keys(filterData);
    let flag = true
    // eslint-disable-next-line no-restricted-syntax
    for (const i of filters) {
      const filter = filterData[i];
      const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
      if (filtersArray?.length && !filtersArray.includes(item[i]?.toLowerCase())) {
        flag = false
      }
    }

    return flag
  }

  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvChartF = document.getElementById('dvChartFilter');
    const dvChartV = document.getElementById('dvChartView');
    dvChartF.style.display = "none";  
    dvChartV.style.display = "none";    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `POS Sales by Product Report ${new Date().getFullYear()}`,
    })
    dvChartF.style.display = "block";  
    dvChartV.style.display = "block"; 
  }

  const callApi = () => {    
    setShowMarketPlaceMessage(false)
    dispatch(handleLoader(true));
    dispatch(getPosSalesByProductData());
  }

  const companyOptions = [];
  // eslint-disable-next-line array-callback-return
  salesByProductData?.modal?.filters?.sort((a, b) => a.sortingOrder - b.sortingOrder).map((data) => {
    data.filterData.forEach((element) => {
        companyOptions.push({
            value: element.key,
            label: element.shortValue
        });
    });
});
const sortedCompanyOptions = companyOptions.sort((a, b) => a.label > b.label ? 1 : -1)

  const changeFilterForCategory = (value) => {
    setCurrentlyShow(value)
  };

  const setMaxValue = useCallback((val) => {
    if (!maxValueObj[val]) {
      setMaxValueObj({ ...maxValueObj, [val]: Number(val) })
    }
  }, [maxValueObj])

  
  // eslint-disable-next-line react/prop-types
  const changeFilter = (value) => {
    setSelectedCompany(value)
  };

  const changeFilterForShow = (value) => {
    setSelectedShowOptions(value)
  };

  useEffect(() => {
    callApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataToShow(salesByProductData?.modal?.data);
  }, [salesByProductData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    if (salesChannelFilterData && !isEqual(salesChannelFilterData, salesChannelRef?.current?.salesChannel || [])) {
      setShowMarketPlaceMessage(true)
      salesChannelRef.current = { [OptChennel]: salesChannelFilterData }
      setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesChannelFilterData])

  let dataToShowForDatesSelected = [];
  dataToShowForDatesSelected = salesByProductData?.modal?.data;
   if (selectedCompany?.length) {
     const selected = selectedCompany?.reduce((acc, item) => {
         acc[item?.value] = item.value
         return acc
     }, {})
     dataToShowForDatesSelected = dataToShowForDatesSelected.filter(item => selected[item.companyName])
 }  

  const tableHeader = [{
    Header: 'Company Name',
    accessor: 'companyName',
    disableGlobalFilter: false,
    width: 120,
    sortType
  },
  {
    Header: 'Year',
    accessor: 'year',
    disableGlobalFilter: false,
    width: 150,
    sortType
  },
  {
    Header: 'Month',
    accessor: 'monthStr',
    disableGlobalFilter: false,
    width: 120,    
    sortType
  }, {
    Header: 'Week',
    accessor: 'week',
    disableGlobalFilter: false,
    width: 120,
    sortType
  }, {
    Header: 'Amount',
    accessor: 'amount',
    disableGlobalFilter: false,
    width: 120,
    rightAlign: true,
    Cell: ({ cell: { row: { original } } }) => {
      // eslint-disable-next-line react/prop-types
      const { amount } = original
      return `${setCurrencyFormat(Number(amount).toFixed(2), true)}`
    }, sortType
  }, {
    Header: 'SKU',
    accessor: 'sku',
    disableGlobalFilter: false,
    width: 120,
    sortType
  }, {
    Header: 'Collection',
    accessor: 'productCollection',
    disableGlobalFilter: false,
    width: 120,
    sortType
  }, {
    Header: 'Category',
    accessor: 'productCategory',
    disableGlobalFilter: false,
    width: 120,
    sortType
  }, {
    Header: 'Sub Category',
    accessor: 'productSubCategory',
    disableGlobalFilter: false,
    width: 120,
    sortType
  }]

  const viewReportButton = () => (
    <div className="view-report">
      <button
        type="button"
        className="view-report btn btn-primary btn-sm"
        onClick={() => setIsOpen(true)}
      >
        View Report
      </button>
    </div>
  )
  const allCategories = {}
  const currentDataByCategory = {};

  const modalData = dataToShowForDatesSelected?.map(item => ({
    ...item,    
  }))
  return (
    <Container className="dashboard">
      <Row className="category-sales">
        <Col sm="12">
          <Card className="pb-3">
            <CardBody className="min-w-50 p-3">
              <div className="card__title mb-2">
                <h5 className="bold-text card__title-center">POS Sales by Product</h5>
              </div>
              <Row className="justify-content-space-between align-items-center">
                <Col sm="8" md="4">
                  <div className="form__form-group mb-0">
                    <span className="form__form-group-label">Company</span>
                    <div className="form__form-group-field">
                      <Select
                        value={selectedCompany}
                        options={sortedCompanyOptions}
                        clearable={false}
                        placeholder="Select "
                        className="select_filter-300"
                        onChange={value => changeFilter(value)}
                        classNamePrefix="react-select"
                        isMulti
                      />
                    </div>

                  </div>
                </Col>
                <Col sm="6" md="3">
                  <div className="form__form-group mb-0">
                    <span className="form__form-group-label">Show</span>
                    <div className="form__form-group-field">
                      <Select
                        value={currentlyShow}
                        options={filterShowWise}
                        clearable={false}
                        placeholder="Select "
                        className="select_filter-show-based"
                        onChange={value => changeFilterForCategory(value)}
                        classNamePrefix="react-select"
                      />
                    </div>

                  </div>
                </Col>
                <Col sm="4" md="2">
                  <div className="form__form-group mb-0">
                    <span className="form__form-group-label">Type</span>
                    <div className="form__form-group-field">
                      <Select
                        value={selectedShowOptions}
                        options={filterWeeklyMonthYear}
                        clearable={false}
                        placeholder="Select "
                        className="select_filter"
                        onChange={changeFilterForShow}
                        classNamePrefix="react-select"
                      // isMulti
                      />
                    </div>

                  </div>
                </Col>               
                <Col md="2">
                <button className="btn btn-sm btn-primary
                                             apply-date-button" style={{marginTop: 40}}  type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button></Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>   
      <div id="divToPrint" ref={container}>
      <Card className="pb-3">
        <CardBody className="">
          <div className="top-location"
            style={{ minHeight: '400' }}>
            <div >
              {isLoading ? <div style={{ minHeight: '200px' }}
                className="row align-items-center justify-content-center">
                <SmallLoader loading={isLoading} />
              </div>
                : <SalesByProductShow
                  dir={rtl.direction}
                  data={dataToShowForDatesSelected}
                  title={`Sales Product By ${selectedShowOptions?.label}`}
                  viewReportButton={viewReportButton}
                  optionShow={selectedShowOptions}
                  companyBasedOn='companyName'
                  categorisedBasedOn={currentlyShow?.value}
                />}
            </div>
          </div>
        </CardBody>
      </Card>
      </div>
      <ViewSalesReportModal
        modalData={modalData}
        isOpen={isOpen}
        handleModal={setIsOpen}
        tableHeaderData={tableHeader}
        title='POS (Sales by product) Report'
        fileName='POS (Sales by product) Report'
      />
    </Container>
  );
};

SalesByProduct.propTypes = {
  dispatch: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
}

export default connect(state => ({
  rtl: state.rtl,
}))(SalesByProduct);